import { CREATE_EVENT, DELETE_EVENT, EDIT_EVENT, GET_EVENT_GRAPH, GET_EVENTS, GET_EVENTS_GRAPH_DATA } from './event.types';

/** Events */

export const getEvents = (params, resourceId, load) => {
    return {
        type: GET_EVENTS,
        payload: { params, resourceId, load },
    };
};
export const getEventsGraphData = (params) => {
    return {
        type: GET_EVENTS_GRAPH_DATA,
        payload: { params },
    };
};

export const createEvent = (body) => {
    return {
        type: CREATE_EVENT,
        payload: { body },
    };
};

export const editEvent = (id, body) => {
    return {
        type: EDIT_EVENT,
        payload: { id, body },
    };
};

export const deleteEvent = (id) => {
    return {
        type: DELETE_EVENT,
        payload: { id },
    };
};

export const getEventGraph = (id) => {
    return {
        type: GET_EVENT_GRAPH,
        payload: { id },
    };
};

/** End */
